"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface TermsAgreementProps {
  onAgree: () => void;
  className?: string;
}

export function TermsAgreement({ onAgree, className }: TermsAgreementProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.2 }}
      className={cn("mb-2 px-2 max-w-lg mx-auto", className)}
    >
      {/* Glassmorphic container - more subtle and minimal */}
      <div
        className={cn(
          "relative rounded-lg",
          "overflow-hidden",
          "bg-[rgba(248,246,255,0.4)]",
          "outline-solid outline-4 outline-[rgba(109,74,255,0.05)]",
          "px-3 py-2"
        )}
        style={{
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(248, 246, 255, 0.5)",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div className="flex flex-row items-center justify-between gap-2">
          <p className="text-[10px] sm:text-[11px] text-gray-500 leading-tight">
            Mit der Nutzung stimmen Sie den{" "}
            <a
              href="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#6D4AFF]/80 hover:text-[#6D4AFF] underline-offset-1 hover:underline transition-colors"
            >
              Nutzungsbedingungen
            </a>{" "}
            und der{" "}
            <a
              href="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#6D4AFF]/80 hover:text-[#6D4AFF] underline-offset-1 hover:underline transition-colors"
            >
              Datenschutzerklärung
            </a>{" "}
            zu
          </p>
          <button
            onClick={onAgree}
            className={cn(
              "px-3 py-1 text-[10px] font-medium",
              "bg-[#6D4AFF]/90 text-white rounded-sm",
              "hover:bg-[#6D4AFF] hover:shadow-xs",
              "transition-all duration-200",
              "shrink-0 whitespace-nowrap"
            )}
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </motion.div>
  );
}
